import { create } from 'zustand';

interface CustomersModal {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export const useValidateCustomersModal = create<CustomersModal>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false })
}));
